import React from 'react'
import Button from '../../atoms/button/button'
import documentIcon from "../../../assets/hoja-check.svg"
import "./dataTreatmentReady.scss"
import { useNavigate } from 'react-router-dom'
import GoBackButton from '../../atoms/go-back-button/goBackButton'

const DataTreatmentReady = () => {

	const navigate = useNavigate();

  return (
	<div className="data-treatment-ready">
		<GoBackButton onClick={() => navigate("/formulario-inicial/")}/>
		<img src={documentIcon} alt="Listo tu concentimiento" />
		<div className="data-treatment-ready__text">
			<h2 className="data-treatment-ready__text__title">Quedó listo tu consentimiento</h2>
			<h3 className="data-treatment-ready__text__subtitle">Para iniciar cuéntanos algunos datos que nos permitan establecer tu perfil</h3>
		</div>
		<Button gtmClass='secondary' onClick={() => navigate('/formulario-inicial/preguntas')} text='Continuar'/>
	</div>
  )
}

export default DataTreatmentReady